import React from 'react';
import GlobalContext from './contexts/GlobalContext';
import WorkspaceContext from './contexts/WorkspaceContext';
import DeliveryContext from './contexts/DeliveryContext';
import BugContext from './contexts/BugContext';
import UserContext from './contexts/UserContext';

const contexts = {
  GlobalContext,
  WorkspaceContext,
  DeliveryContext,
  BugContext,
  UserContext,
};

const Domains = {
  Provider: ({ children }: { children?: React.ReactNode; value?: Record<string, string> }) => {
    return (
      <>
        <GlobalContext.Provider>
          <UserContext.Provider>
            <DeliveryContext.Provider>
              <BugContext.Provider>
                <WorkspaceContext.Provider>{children}</WorkspaceContext.Provider>
              </BugContext.Provider>
            </DeliveryContext.Provider>
          </UserContext.Provider>
        </GlobalContext.Provider>
      </>
    );
  },
};

export { Domains, contexts };
